import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import {
  reducerGetVacancyList,
  reducerVacancyStatus,
  reducerVacancyStatusMessage,
  reducerVacancyFiltersList,
} from "../../reducer/recruiting/reducers/reducerVacancy";
import {
  reducerSingleVacancyStatus,
  reducerSingleVacancyStatusMessage,
  reducerGetSingleVacancy,
  reducerSort
} from "../../reducer/recruiting/reducers/reducerSingleVacancy";
import {
  reducerRoutesStatus,
  reducerRoutesStatusMessage,
} from "../../reducer/projects/reducers/reducerRoutesList";
import {
  reducerVacantRoutesStatus,
  reducerVacantRoutesStatusMessage,
} from "../../reducer/projects/reducers/reducerVacantRoutesList";

import { formatErrorMessage } from "../../../utils/formatError";
import { ICreateVacancyOptions, IVacancyInputValuesOptions } from "../../../types/vacancyInterfeces";
import {
  reducerCreateVacancyInputValues,
  reducerHandleErrors
} from "../../reducer/recruiting/reducers/reducerCreateVacancy";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetVacancies =
  (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    const store = getState();
    const filter = store.recruiting.vacancyList.vacancyListInputValues;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/projects/vacancy/list`,
        { limit, page, ...filter }
      );
      dispatch(reducerGetVacancyList({ data: response.data }));
    } catch (e: any) {
      if (e.response.status === 401) {
        window.location.href = "/login";
      }
      if (e.response.status === 403) {
        window.location.href = "/";
      }
    }
  };

export const actionCreateVacancy =
  (data: ICreateVacancyOptions, page: string, navigate?: (page: string) => void) => async (dispatch: AppDispatch) => {
    console.log(page);
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/projects/vacancy`,
        data
      );
      if (page === '2' || page === '5') {
        dispatch(reducerSingleVacancyStatus(201));
        dispatch(reducerSingleVacancyStatusMessage('Вакансия успешно создана'));
      }
      if (page === '1') {
        dispatch(reducerSingleVacancyStatus(201));
        dispatch(reducerSingleVacancyStatusMessage('Вакансия успешно создана'));
      }
      if (page === '4') {
        dispatch(reducerSingleVacancyStatus(201));
        dispatch(reducerSingleVacancyStatusMessage('Вакансия успешно создана'));
      }

      if (response?.status !== 200) {
        dispatch(reducerCreateVacancyInputValues([]));
        dispatch(reducerHandleErrors([]));
      } else if (navigate) {
        navigate(`/recruiting/vacancy/${response.data.id}`);
      }
      return response;
    } catch (e: any) {
      dispatch(reducerVacancyStatus(400));
      dispatch(
        reducerVacancyStatusMessage(formatErrorMessage(e?.response?.data))
      );
      dispatch(reducerRoutesStatus(401));
      dispatch(
        reducerRoutesStatusMessage(formatErrorMessage(e?.response?.data))
      );
      dispatch(reducerVacantRoutesStatus(401));
      dispatch(
        reducerVacantRoutesStatusMessage(formatErrorMessage(e?.response?.data))
      );
    }
  };

export const actionGetSingleVacancy =
  (id: string | undefined) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/projects/vacancy/${id}?id=${id}`
      );
      dispatch(reducerGetSingleVacancy(response.data));
    } catch (err: any) {
      if (err.response?.status === 403 || err.response?.status === 404) {
        dispatch(reducerSingleVacancyStatus(400));
        dispatch(
          reducerSingleVacancyStatusMessage('У вас нет прав доступа к запрашиваемому ресурсу.')
        );
      }
    }

  };

export const actionTest =
  (id: any) => async (dispatch: AppDispatch) => {
  };

export const actionUpdateVacancy =
  (data: IVacancyInputValuesOptions) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/projects/vacancy/update`,
        data
      );
      dispatch(reducerSort(false));

      dispatch(reducerGetSingleVacancy(response.data));
      return response
    } catch (e: any) {
      dispatch(reducerSingleVacancyStatus(e.response.status));
      dispatch(
        reducerSingleVacancyStatusMessage(formatErrorMessage(e.response.data))
      );
      return e.response;
    }
  };

export const actionVacanciesExport = (arrayId?: number[], email?: string) => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common['Authorization'] = token;
  try {
    const response = await axios.post(
      `${BASE_URL}/json/projects/vacancy/export`,
      arrayId
    );
    if (response.status === 200) {
      dispatch(reducerVacancyStatus(0));
      dispatch(reducerVacancyStatusMessage(`Данные будут отправлены на почту ${email}!`));
    }
    return response
  } catch {
    console.log('err');
  };
}

export const actionVacanciesFilters = () => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common['Authorization'] = token;
  try {
    const response = await axios.get(
      `${BASE_URL}/json/projects/vacancy/filter`
    );
    dispatch(reducerVacancyFiltersList({ data: response.data }))
  } catch (e: any) {
    if (e.response.status === 403) {
      window.location.href = "/";
    }
  }
}

export const actionRemoveSelections =
  (vacancy: number) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/projects/vacancy/${vacancy}/unmark`,
      );
      dispatch(reducerGetSingleVacancy(response.data));
    } catch (e) {
      return e;
    }
  };
